import angular from 'angular';
import moment from 'moment';

angular.module('cloudX').directive('cxYearSelectXedit', [
  function() {
    return {
      restrict: 'E',
      template: `<a href="#" editable-select="value" onbeforesave="setValue($data)"
                    blur="submit" edit-disabled="disabled"
                    e-ng-options="item.id as item.label for item in options">
                      <span ng-show="value && value!==0">{{value}}</span>
                      <span ng-show="value===0 && withoutOption">{{withoutOption}}</span>
                      <i class="glyphicon glyphicon-pencil" ng-show="!value && (value!==0 || !withoutOption)"></i>
                  </a>`,
      scope: {
        value: '=',
        required: '@',
        placeholder: '@',
        withoutOption: '@',
        disabled: '=?',
        yearsInPast: '@?',
        yearsInFuture: '@?',
        save: '&',
      },
      controller: [
        '$scope',
        function($scope) {
          $scope.options = [];

          $scope.resetOptions = () => {
            $scope.options = [];
            const currentYear = moment.utc().year();
            const yearsInPast = angular.isDefined($scope.yearsInPast)
              ? parseInt($scope.yearsInPast, 10)
              : 5;
            const yearsInFuture = angular.isDefined($scope.yearsInFuture)
              ? parseInt($scope.yearsInFuture, 10)
              : 1;

            const startYear = currentYear - Math.max(0, yearsInPast || 0);
            const endYear = currentYear + Math.max(0, yearsInFuture || 0);

            if (!$scope.required) {
              $scope.options.push({ id: null, label: $scope.placeholder || '' });
            }
            if ($scope.withoutOption) {
              $scope.options.push({ id: 0, label: $scope.withoutOption });
            }

            for (let y = startYear; y <= endYear; y++) {
              $scope.options.push({ id: y, label: y });
            }

            if (
              $scope.value &&
              $scope.value !== 0 &&
              $scope.options.findIndex(x => x.id === $scope.value) < 0
            ) {
              $scope.options.push({ id: $scope.value, label: $scope.value });
            }
          };
          $scope.setValue = function(value) {
            if ((value === '0' || value === 0) && !!$scope.withoutOption) {
              $scope.save({ newValue: 0 });
              return;
            }

            if (!value || value < 2000) {
              $scope.save({ newValue: null });
            } else {
              $scope.save({ newValue: parseInt(value) });
            }
          };

          this.$onInit = () => {
            $scope.resetOptions();
          };
        },
      ],
    };
  },
]);
